import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutInstructor } from './components/AboutInstructor';
import { WhyJoinUs } from './components/WhyJoinUs';
import { Services } from './components/Services';
import { ClassSchedule } from './components/ClassSchedule';
import { Testimonials } from './components/Testimonials';
import { Gallery } from './components/Gallery';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ContactUs } from './components/ContactUs';
import { Footer } from './components/Footer';
export function App() {
  return <div className="font-sans text-yoga-dark bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutInstructor data-id="element-4" />
        <WhyJoinUs data-id="element-5" />
        <Services data-id="element-6" />
        <ClassSchedule data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Gallery data-id="element-9" />
        <Pricing data-id="element-10" />
        <FAQ data-id="element-11" />
        <ContactUs data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}